document.addEventListener('DOMContentLoaded', function() {
  const questions = document.querySelectorAll('.faq-section .question');

  questions.forEach(function(question) {
    question.addEventListener('click', function() {
      const answer = question.nextElementSibling;

      if (answer.style.display === 'block') {
        answer.style.display = 'none';
        question.classList.remove('active');
      } else {
        answer.style.display = 'block';
        question.classList.add('active');
      }
    });
  });
});